import { render, staticRenderFns } from "./ApprovalHeadForm.vue?vue&type=template&id=666f61cf&scoped=true&"
import script from "./ApprovalHeadForm.vue?vue&type=script&lang=js&"
export * from "./ApprovalHeadForm.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalHeadForm.vue?vue&type=style&index=0&id=666f61cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666f61cf",
  null
  
)

export default component.exports